"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _nuiIntl = require("@concur/nui-intl");

var _trackClick = require("../HOCs/trackClick");

var ListingsActions = _interopRequireWildcard(require("../listings/listingsModule"));

var _AnalyticsModule = require("../analytics/modules/AnalyticsModule");

var _SearchBar = _interopRequireDefault(require("./SearchBar"));

var _CategoryMenu = _interopRequireDefault(require("./CategoryMenu"));

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/Header.css") : void 0;

var _utils = require("../utils");

var _withAppContext = require("../HOCs/withAppContext");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Header = function Header(_ref) {
  var search = _ref.search,
      setSearch = _ref.setSearch,
      setSearchAndFilter = _ref.setSearchAndFilter,
      setCategory = _ref.setCategory,
      clearSearch = _ref.clearSearch,
      category = _ref.category,
      categories = _ref.categories,
      setAndFilterByCategory = _ref.setAndFilterByCategory,
      enableLiveSearch = _ref.enableLiveSearch,
      filterApps = _ref.filterApps,
      router = _ref.router,
      location = _ref.location,
      host = _ref.host,
      listingId = _ref.listingId,
      listings = _ref.listings,
      companyUUID = _ref.companyUUID,
      userId = _ref.userId,
      trackCategoryLinkClick = _ref.trackCategoryLinkClick,
      getTitle = _ref.getTitle,
      profile = _ref.profile;

  var handleHeaderClick = function handleHeaderClick() {
    if (router.location.pathname !== (0, _utils.getAppCenterPathName)(location.pathname)) {
      setCategory();
    }

    clearSearch();
    setSearch();
    setCategory();
    router.push((0, _utils.getAppCenterPathName)(location.pathname));
  };

  return _react.default.createElement("div", null, _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12 col-sm-7 col-xs-12"
  }, _react.default.createElement(_trackClick.Tracked, {
    event: "CLICK",
    additional: {
      context: router.location.pathname === (0, _utils.getAppCenterPathName)(location.pathname) ? 'HOME' : 'LISTING_DETAILS',
      type: 'LINK',
      value: 'APPCENTER_HEADER',
      domain: {
        host: host
      }
    }
  }, _react.default.createElement("h2", {
    className: "appcenter-title",
    onClick: handleHeaderClick
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "AppCenterHeader"
  })))), _react.default.createElement("div", {
    className: "col-xs-5 col-sm-5 col-xs-12"
  }, _react.default.createElement(_SearchBar.default, {
    search: search,
    onChange: enableLiveSearch ? setSearchAndFilter : setSearch,
    filterApps: filterApps
  }))), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12 col-sm-5"
  }, _react.default.createElement(_CategoryMenu.default, {
    display: !listingId && listings.length >= 20,
    category: category,
    categories: categories,
    companyUUID: companyUUID,
    userId: userId,
    setAndFilterByCategory: setAndFilterByCategory,
    trackCategoryLinkClick: trackCategoryLinkClick
  })), _react.default.createElement("div", {
    className: "col-sm-7 appcenter-help"
  }, listingId !== 'help' && _react.default.createElement(_reactRouter.Link, {
    to: "".concat((0, _utils.getAppCenterPathName)(location.pathname), "/help"),
    onClick: function onClick() {
      return document.title = getTitle('Help');
    }
  }, _react.default.createElement("span", null, "Need help?")))));
};

Header.propTypes = {
  search: _propTypes.default.string.isRequired,
  setSearch: _propTypes.default.func,
  setSearchAndFilter: _propTypes.default.func.isRequired,
  setCategory: _propTypes.default.func.isRequired,
  clearSearch: _propTypes.default.func.isRequired,
  filterApps: _propTypes.default.func.isRequired,
  setAndFilterByCategory: _propTypes.default.func.isRequired,
  categories: _propTypes.default.arrayOf(_propTypes.default.object),
  enableLiveSearch: _propTypes.default.bool,
  location: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  router: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  host: _propTypes.default.string,
  trackCategoryLinkClick: _propTypes.default.func,
  companyUUID: _propTypes.default.string,
  userId: _propTypes.default.string,
  profile: _propTypes.default.object
};

var HeaderWrapper =
/*#__PURE__*/
function (_Component) {
  _inherits(HeaderWrapper, _Component);

  function HeaderWrapper() {
    _classCallCheck(this, HeaderWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(HeaderWrapper).apply(this, arguments));
  }

  _createClass(HeaderWrapper, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement(Header, _extends({}, this.props, {
        getTitle: this.props.context.getTitle
      })));
    }
  }]);

  return HeaderWrapper;
}(_react.Component);

function mapStateToProps(state) {
  return {
    listings: state.listings.list,
    search: state.listings.search,
    categories: state.listings.categories,
    category: state.listings.category,
    host: state.meta.host,
    companyUUID: state.userPrefs.companyUUID,
    userId: state.userPrefs.userId,
    profile: state.userProfile.profile
  };
}

var mappedHeader = (0, _reactRedux.connect)(mapStateToProps, {
  setSearch: ListingsActions.setSearch,
  setCategory: ListingsActions.setCategory,
  clearSearch: ListingsActions.clearSearch,
  setSearchAndFilter: ListingsActions.setAndFilter,
  filterApps: ListingsActions.filterListingsByAll,
  setAndFilterByCategory: ListingsActions.setAndFilterByCategory,
  trackCategoryLinkClick: _AnalyticsModule.linkClickDispatch
})(HeaderWrapper);

var _default = (0, _reactRouter.withRouter)((0, _withAppContext.withAppContext)(mappedHeader));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/Header.js
// module id = 27
// module chunks = 0